export function getPlateType (data) {
  if (data) {
    if (data === 'CUSTOM_SAMPLE_PLATE') {
      return '客户样本版'
    } else if (data === 'PCR_PLATE') {
      return 'PCR板'
    } else if (data === 'DEEP_WELL_PLATE') {
      return '深孔板'
    } else if (data === 'ELISA_PLATE') {
      return '酶标板'
    } else if (data === 'SAMPLE_PLATE') {
      return '点样板'
    } else if (data === 'HYBRIDIZATION_SAMPLE_PLATE') {
      return '杂交板/芯片'
    } else if (data === 'CHIP') {
      return '杂交板/芯片'
    } else if (data === 'INDEX_BUILD_PLATE') {
      return '文库构建板'
    }
  } else {
    return '--'
  }
}
